<template>
  <div class="container-fluid pt-3">
    <h3 class="mb-3">Избранные назначения</h3>

    <div class="card p-3 border-bottom-0 border-left-0 border-right-0 border-primary border-top mb-3 shadow">
      <div class="row">
        <div class="col-6">
          <div class="form-group pt-3">
            <div class="input-group">
              <div class="input-group-btn">
                <button type="button" class="btn btn-primary" @click="addPrescriptions">
                  Добавить выбранные ({{selectedPrescriptions.length}}) к
                </button>
              </div>

              <select class="form-control" v-model="client" id="drug">
                <option value="" selected>Выберите клиента...</option>
                <option v-for="(item, index) in clients" :key="index" :value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="list-group" v-for="(prescription, key) in favorites" :key="key">
        <div :class="'list-group-item ' + (isSelected(prescription.id) ? 'list-group-item-primary' : '')"
             v-on:click="toogleSelection(prescription.id)">
          <div class="row pointer">
            <div class="col-2">
              <span class="text-dark">
                {{prescription.drug.ingredient.name}}
              </span>
            </div>
            <div class="col-1">
              {{prescription.drug.measure}}
              {{prescription.drug.measureUnit}}
            </div>
            <div class="col-1">
              {{ prescription.quantity }}
              {{ prescription.drug.format.name.substring(0, 3) }}.
            </div>
            <div class="col-4">
              <small>
                {{ prescription.times.map(time => time.name).join(', ') }},
                {{ prescription.methods.map(method => method.name).join(', ') }}
              </small>
            </div>
            <div class="col-1">
              {{duration(prescription)}}
            </div>
            <div class="col-3">
              {{ prescription.drug.name }}
              {{prescription.drug.manufacturer ? prescription.drug.manufacturer.name : ''}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {MS_IN_DAY} from '../constants';

  export default {
    data() {
      return {
        selectedPrescriptions: [],
        client: '',
      };
    },

    created() {
      this.client = this.$store.state.clientId || '';
    },

    computed: {
      favorites() {
        return this.$store.state.favorites;
      },

      clients() {
        return this.$store.state.clients;
      },
    },

    watch: {
      client() {
        this.$store.dispatch('CHOOSE_CLIENT', this.client);
      },
    },

    methods: {
      duration(prescription) {
        const diff = new Date(prescription.finishDate).getTime() - new Date(prescription.startDate).getTime();
        const days = parseInt(diff / MS_IN_DAY) + 1;
        const months = parseInt(days / 30);

        return months > 0 ? `${months} мес.` : `${days} дн.`;
      },

      isSelected(id) {
        return this.selectedPrescriptions.includes(id);
      },

      toogleSelection(id) {
        if (!this.selectedPrescriptions.includes(id)) {
          this.selectedPrescriptions.push(id);
        } else {
          this.selectedPrescriptions = this.selectedPrescriptions.filter(item => item !== id);
        }
      },

      async addPrescriptions() {
        try {
          for (const prescription of this.favorites) {
            if (!this.selectedPrescriptions.includes(prescription.id)) {
              continue;
            }

            const dateDiff = new Date(prescription.finishDate).getTime() - new Date(prescription.startDate).getTime();

            const data = {
              client: this.client,
              drug: prescription.drug.id,
              quantity: prescription.quantity,
              startDate: new Date(),
              finishDate: new Date(Date.now() + dateDiff),
              times: prescription.drug.times.map(time => time.id),
              methods: prescription.drug.methods.map(method => method.id),
              comment: prescription.comment,
            };

            await this.$store.dispatch('ADD_DRUG_PRESCRIPTION', { data });

            this.$store.dispatch('CHANGE_VIEW', 'clients');
          }
        } catch (e) {
          await this.$store.dispatch('ERROR', e);
        }
      },
    }
  };
</script>
